




















































import OnsiteSearchResult from './OnsiteSearchResult.vue';
import { mapGetters, mapActions } from 'vuex';
import OnsiteSearchNoResult from './OnsiteSearchNoResult.vue';

export default {
  name: "OnsiteSearch",
  components: {
    OnsiteSearchResult,
    OnsiteSearchNoResult  
  },
  data() {
    return {
      query: '',
      initalTab: ''
    }
  },
  computed: mapGetters(['getTranslations', 'getQueryString', 'getProductTotalResults', 'getGroups', 'getTotalResults']),  
  methods: {
    ...mapActions(['initialize']),
    startSearch() {
      // check query
      var s = this.query
      if (s.length > 0 && s.indexOf('<') > 0) 
        s = s.substring(0,s.indexOf('<'))
      this.query = s

      // create a new entry in the browser's history, without reloading
      window.history.pushState({}, document.title, window.location.origin + window.location.pathname + "?s=" + this.query)

      this.runSearch()
    },
    runSearch() {
      //console.log("Start Search with query: " + this.query)
      this.$store.dispatch("setQueryString", this.query)
      this.$store.dispatch("setInitialTab", this.initalTab)

      if (this.query != "") {
        this.initialize()
      }
    },
    clearSearch() {
      this.$store.dispatch("setQueryString", "");
      this.query = "";
    }    
  },
  mounted() {
    // check for query parameter
    let params = new URLSearchParams(document.location.search.substring(1));
    var s = params.get("s"), t = params.get("t")
    if (s !== null && s !== "") {
      if (s.length > 0 && s.indexOf('<') > 0) s = s.substring(0,s.indexOf('<'))
      if (t !== null && t !== "") this.initalTab = t
      this.query = s
      this.runSearch()
    }

    // create observer to check tab status
    const attrObserver = new MutationObserver((mutations) => {
        mutations.forEach(mu => {
            if (mu.type !== "attributes" && mu.attributeName !== "class") return;
            if (mu.target.nodeType == 1) {
                let searchContainer = mu.target as HTMLDivElement
                if (typeof searchContainer === undefined) return
                if (searchContainer!.getAttribute("class")!.indexOf("mdl-onsite-search__content--overview") >= 0) {
                    this.$store.dispatch("setAllTabSelected", true)
                } else {
                    this.$store.dispatch("setAllTabSelected", false)
                }
            }
        });
    });
    const contentContainer = document.querySelectorAll(".mdl-onsite-search__content");
    contentContainer.forEach(el => attrObserver.observe(el, {attributes: true}));
  },
  created() {
  }
};
